var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoresult(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 64,
    viewBox: "0 0 72 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2138 54.1934H9.45517C7.20576 54.1934 5.37573 52.3367 5.37573 50.0544V4.13897C5.37573 1.85673 7.20576 0 9.45517 0H41.2138C43.4632 0 45.2932 1.85673 45.2932 4.13897V50.0544C45.2932 52.3367 43.4632 54.1934 41.2138 54.1934Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.507 56.127H6.74838C4.49897 56.127 2.66895 54.2703 2.66895 51.988V6.07256C2.66895 3.79033 4.49897 1.93359 6.74838 1.93359H38.507C40.7564 1.93359 42.5864 3.79033 42.5864 6.07256V51.988C42.5864 54.2703 40.7564 56.127 38.507 56.127Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8762 57.7156H4.07944C1.83003 57.7156 0 55.8589 0 53.6153V7.89326C0 5.61102 1.83003 3.79297 4.07944 3.79297H35.8762C38.1256 3.79297 39.9556 5.6497 39.9556 7.89326V53.6153C39.9556 55.8975 38.1256 57.7156 35.8762 57.7156Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8762 57.7156H4.07944C1.83003 57.7156 0 55.8589 0 53.6153V7.89326C0 5.61102 1.83003 3.79297 4.07944 3.79297H35.8762C38.1256 3.79297 39.9556 5.6497 39.9556 7.89326V53.6153C39.9556 55.8975 38.1256 57.7156 35.8762 57.7156Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3011 17.6393H7.81572C7.12946 17.6393 6.5957 17.0977 6.5957 16.4788C6.5957 15.8599 7.12946 15.3184 7.81572 15.3184H31.3011C31.9873 15.3184 32.5211 15.8599 32.5211 16.4788C32.5211 17.0977 31.9873 17.6393 31.3011 17.6393Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3011 24.7174H7.81572C7.12946 24.7174 6.5957 24.1759 6.5957 23.5569C6.5957 22.938 7.12946 22.3965 7.81572 22.3965H31.3011C31.9873 22.3965 32.5211 22.938 32.5211 23.5569C32.5211 24.1759 31.9873 24.7174 31.3011 24.7174Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3011 31.7955H7.81572C7.12946 31.7955 6.5957 31.254 6.5957 30.6351C6.5957 30.0162 7.12946 29.4746 7.81572 29.4746H31.3011C31.9873 29.4746 32.5211 30.0162 32.5211 30.6351C32.5211 31.254 31.9873 31.7955 31.3011 31.7955Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.3011 38.8756H7.81572C7.12946 38.8756 6.5957 38.3341 6.5957 37.7151C6.5957 37.0962 7.12946 36.5547 7.81572 36.5547H31.3011C31.9873 36.5547 32.5211 37.0962 32.5211 37.7151C32.5211 38.3341 31.9873 38.8756 31.3011 38.8756Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0541 45.9147H7.77763C7.09137 45.9147 6.55762 45.3731 6.55762 44.7542C6.55762 44.1353 7.09137 43.5938 7.77763 43.5938H20.0541C20.7403 43.5938 21.2741 44.1353 21.2741 44.7542C21.2741 45.3731 20.7403 45.9147 20.0541 45.9147Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7975 36.7859C40.1081 41.5438 32.8261 42.0853 27.5266 38.4105C26.8404 37.9464 26.1922 37.4048 25.6203 36.7859C25.3153 36.4764 25.0103 36.167 24.7435 35.8188C24.2097 35.1226 23.7141 34.4263 23.3328 33.6913C22.6465 32.4148 22.1509 31.0997 21.9222 29.7071C21.0834 25.3747 22.3415 20.7329 25.6203 17.3676C28.9373 14.0022 33.5123 12.7644 37.7824 13.5767C39.1549 13.8475 40.4512 14.3117 41.7093 15.008C42.4337 15.4335 43.1581 15.8977 43.8062 16.4392C44.1494 16.71 44.4544 17.0194 44.7594 17.3289C45.3694 17.9478 45.9032 18.6054 46.3607 19.263C49.9826 24.6011 49.4488 31.9893 44.7594 36.7472L44.7975 36.7859Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5013 35.8606C38.6212 40.8119 30.6911 40.8119 25.811 35.8606C20.931 30.9093 20.931 22.8634 25.811 17.9122C30.6911 12.9609 38.6212 12.9609 43.5013 17.9122C48.3814 22.8634 48.3814 30.9093 43.5013 35.8606ZM45.9795 15.3592C39.6887 8.97664 29.5473 8.97664 23.2566 15.3592C16.9659 21.7417 16.9659 32.0311 23.2566 38.4136C28.9755 44.2159 37.935 44.7187 44.2257 39.9609C44.8357 39.4967 45.4457 38.9551 45.9795 38.4136C46.5513 37.8334 47.047 37.2531 47.5045 36.6342C52.1939 30.2517 51.6602 21.1614 45.9795 15.3978V15.3592Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6847 62.3954L70.4178 62.6661C68.6641 64.4455 65.8047 64.4455 64.089 62.6661L48 46.3424L54.5957 39.6504L70.6847 55.9742C72.4385 57.7535 72.4385 60.6547 70.6847 62.3954Z",
    fill: "url(#paint0_linear_21_21704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8856 36.1309L52.6513 40.9661L49.2581 44.4088L44.4924 39.5735C45.1024 39.1094 45.7124 38.5678 46.2843 37.9876C46.8562 37.4074 47.39 36.7885 47.8475 36.1695L47.8856 36.1309Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.456 55.7812L63.8984 62.4345L62.7166 61.2353L69.2742 54.582L70.456 55.7812Z",
    fill: "#20C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.939 39.8827L48.1907 46.7294L47.1995 45.7237L53.9477 38.877L54.939 39.8827Z",
    fill: "url(#paint1_linear_21_21704)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2607 16.2101L23.7142 32.9981C23.1042 31.8763 22.6848 30.6771 22.4561 29.4393L36.7531 14.9336C37.9732 15.1657 39.1551 15.5912 40.2607 16.2101Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6744 20.1936L27.7935 37.291C27.1454 36.8655 26.5354 36.4014 25.9635 35.8211C25.6585 35.5504 25.3916 35.2409 25.1248 34.9701L43.1963 17.6406C43.5013 17.8727 43.8063 18.1435 44.1113 18.4529C44.6832 18.9945 45.1788 19.5747 45.6363 20.1936H45.6744Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_21704",
    x1: 72.9341,
    y1: 40.5788,
    x2: 48.5671,
    y2: 64.5954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20C3FF",
    stopOpacity: 0.07
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_21704",
    x1: 54.939,
    y1: 38.877,
    x2: 47.0874,
    y2: 46.6156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49B2DE"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresult);
export default __webpack_public_path__ + "static/media/noresult.5125b6c2fbd0e0eec747edff8fe25ba1.svg";
export { ForwardRef as ReactComponent };